<template>
  <div class="supplier" v-if="joinType == 1">
    <div class="first">
      <div class="bigTitle">
        <div class="line"></div>
        <div class="topic">公司介绍</div>
      </div>
      <div>
        <div class="sup_cont">
          1.
          修正健康商城是修正集团旗下B2C大健康领域旗舰平台，致力于打造以医药健康产品为核心，专业科普内容为抓手，数字化驱动为赋能，以消费者为中心，依托自身优势，整合国内外各类行业资源，构建一个以“健康、医药、医疗”三大领域为核心的大健康产业互联网服务平台，为用户提供高品质的医药健康产品和专业的医疗健康服务。
        </div>
        <div class="sup_cont" style="margin-top: 0.26rem">
          2.
          为了满足公司的业务发展需求，修正健康从消费者的需求角度出发建立热招品类品牌榜，寻找好商品和好品牌，共同为消费者提供优质的商品和服务，我们诚邀各类供应商加入我们的合作伙伴行列，共同发展和创新。
        </div>
      </div>
    </div>
    <div class="second">
      <div class="bigTitle">
        <div class="line"></div>
        <div class="topic">热招品类</div>
      </div>
      <div class="cate">
        <div class="cate_item">医药保健</div>
        <div class="cate_item">食品酒水</div>
        <div class="cate_item">美妆个护</div>
        <div class="cate_item">医疗器械</div>
        <div class="cate_item">创意礼品</div>
        <div class="cate_item">虚拟充值</div>
      </div>
    </div>
    <div class="third">
      <div class="bigTitle">
        <div class="line"></div>
        <div class="topic">热招商家</div>
      </div>
      <div class="busniss">
        <div>
          <div class="chanye">产业带/实力工厂</div>
          <div class="chanye_cont">
            自有生产能力，强供应链能力和价格优势、组货能力
          </div>
        </div>
        <div class="split"></div>
        <div>
          <div class="chanye">品牌商</div>
          <div class="chanye_cont">
            知名品牌，良好的信誉和口碑，可靠的交货能力，符合行业的生产能力和经验，提供符合质量标准的产品
          </div>
        </div>
        <div class="split"></div>
        <div>
          <div class="chanye">集合性商家</div>
          <div class="chanye_cont">品种丰富度高，合作模式灵活</div>
        </div>
      </div>
    </div>
    <div class="fourth">
      <div class="bigTitle">
        <div class="line"></div>
        <div class="topic">供应商合作流程</div>
      </div>
      <div class="flowImg">
        <div class="once">
          <img class="step" src="../../../assets/images/step1.png" alt="" />
          <div class="stepWord">提交申请</div>
          <div class="stepCont">
            提供企业基本信息、产品信息、生产能力等相关资料
          </div>
        </div>
        <img class="point" src="../../../assets/images/right.png" alt="" />
        <div class="once">
          <img class="step" src="../../../assets/images/step2.png" alt="" />
          <div class="stepWord">资格审核</div>
          <div class="stepCont">
            供应商需具备相关的行业资质、产品认证或生产许可证等，提交后平台会在3个工作日内审核
          </div>
        </div>
        <img class="point" src="../../../assets/images/right.png" alt="" />
        <div class="once">
          <img class="step" src="../../../assets/images/step3.png" alt="" />
          <div class="stepWord">合作签约</div>
          <div class="stepCont">
            审核通过后，会有专人与供应商签订合作协议，明确双方的权利和义务
          </div>
        </div>
      </div>
      <div class="flowImg" style="margin-top: 0.8rem">
        <div class="once">
          <img class="step" src="../../../assets/images/step4.png" alt="" />
          <div class="stepWord">订单处理</div>
          <div class="stepCont">
            客户下单后，健康商城接收订单和推单，供应商负责发货和售后服务
          </div>
        </div>
        <img class="point" src="../../../assets/images/right.png" alt="" />
        <div class="once">
          <img class="step" src="../../../assets/images/step5.png" alt="" />
          <div class="stepWord">销售推广</div>
          <div class="stepCont">
            平台会通过各种渠道对供应商的产品进行推广，提高产品销量
          </div>
        </div>
        <img class="point" src="../../../assets/images/right.png" alt="" />
        <div class="once">
          <img class="step" src="../../../assets/images/step6.png" alt="" />
          <div class="stepWord">产品上架</div>
          <div class="stepCont">
            供应商提供产品信息和图片，平台审核后将产品上架
          </div>
        </div>
      </div>
      <div class="connection">
        <div>
          <div class="con_cont">
            如有合作意向，请与我们联系，欢迎来电，期待与您建立长久、稳定的合作关系，共同发展和创新！
          </div>
          <div class="con_person">联系方式：王经理</div>
        </div>
        <div style="text-align: center">
          <div class="qrcode">
            <img
              style="width: 1.71rem; height: 1.77rem"
              src="../../../assets/images/wxCode.png"
              alt=""
            />
          </div>
          <div class="addWx">（扫码加微信）</div>
        </div>
      </div>
    </div>
    <div class="fifth">
      <div class="apply">
        <div class="namePhone">
          <div>
            <div class="word">您的姓名：</div>
            <input class="input" v-model.trim="form.name" type="text" />
          </div>
          <div style="margin-left: 0.65rem">
            <div class="word">联系电话：</div>
            <input
              class="input"
              v-model.trim="form.mobile"
              maxlength="11"
              type="text"
            />
          </div>
        </div>
        <div class="namePhone">
          <div>
            <div class="word1">公司名称：</div>
            <input class="input" v-model.trim="form.company_name" type="text" />
          </div>
          <div style="margin-left: 0.65rem">
            <div class="word1">产品品类：</div>
            <input
              class="input"
              v-model.trim="form.product_cat"
              maxlength="11"
              type="text"
            />
          </div>
        </div>
        <div class="detail">
          <div class="word1">热销产品：</div>
          <input class="input" v-model.trim="form.hot_products" type="text" />
        </div>
        <div class="detail">
          <div class="word">详细信息：</div>
          <textarea
            class="textArea"
            v-model.trim="form.contentText"
            placeholder="请输入您的详细信息，我们会尽快联系您（300字以内）"
          ></textarea>
        </div>
      </div>
      <div class="submit">
        <div class="button" @click="submitform">提交申请</div>
        <div class="tip">收到信息我们会第一时间与您联系！</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    joinType: {
      type: Number,
    },
  },
  data() {
    return {
      form: {
        contentText: "",
        mobile: "",
        name: "",
        company_name: "",
        product_cat: "",
        hot_products: "",
      },
    };
  },
  mounted() {},
  methods: {
    submitform() {
      this.$emit("submitApply", {
        name: this.form.name,
        mobile: this.form.mobile,
        contentText: this.form.contentText,
        company_name: this.form.company_name,
        product_cat: this.form.product_cat,
        hot_products: this.form.hot_products,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.supplier {
  padding: 0.38rem 3.6rem 0;
  .first {
    .sup_cont {
      font-family: OPPOSans, OPPOSans;
      font-weight: normal;
      font-size: 0.2rem;
      color: #666666;
    }
  }
  .second {
    .cate {
      display: flex;
      justify-content: space-between;
      .cate_item {
        width: 1.8rem;
        height: 0.64rem;
        line-height: 0.64rem;
        background: #e4eeff;
        border-radius: 0.32rem;
        font-family: OPPOSans, OPPOSans;
        font-weight: normal;
        font-size: 0.26rem;
        color: #4089fe;
        text-align: center;
      }
    }
  }
  .third {
    .busniss {
      display: flex;
      justify-content: space-between;
      .chanye {
        font-family: OPPOSans, OPPOSans;
        font-weight: normal;
        font-size: 0.26rem;
        color: #232323;
      }
      .chanye_cont {
        margin-top: 0.2rem;
        width: 3.6rem;
        font-family: OPPOSans, OPPOSans;
        font-weight: normal;
        font-size: 0.2rem;
        color: #666666;
      }
      .split {
        width: 0.01rem;
        height: 1.52rem;
        background: #ececed;
      }
    }
  }
  .fourth {
    .flowImg {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .once {
        width: 3rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        .step {
          width: 0.9rem;
          height: 0.9rem;
        }
        .stepWord {
          margin-top: 0.1rem;
          font-family: OPPOSans, OPPOSans;
          font-weight: normal;
          font-size: 0.28rem;
          color: #4089fe;
        }
        .stepCont {
          margin-top: 0.2rem;
          font-family: OPPOSans, OPPOSans;
          font-weight: normal;
          font-size: 0.2rem;
          color: #666666;
          text-align: center;
        }
      }
      .point {
      }
    }
    .connection {
      margin-top: 0.72rem;
      display: flex;
      justify-content: space-between;
      width: 12rem;
      height: 3.2rem;
      padding: 0.74rem 1.02rem 0 0.7rem;
      box-sizing: border-box;
      background: #fcfbff;
      .con_cont {
        width: 6.71rem;
        font-family: OPPOSans, OPPOSans;
        font-weight: 600;
        font-size: 0.26rem;
        color: #232323;
      }
      .con_person {
        margin-top: 0.25rem;
        font-family: OPPOSans, OPPOSans;
        font-weight: normal;
        font-size: 0.24rem;
        color: #232323;
      }
      .qrcode {
        width: 1.83rem;
        height: 1.83rem;
        line-height: 1.83rem;
        background: #ffffff;
        border-radius: 0.12rem;
        border: 0.03rem solid #4089fe;
        text-align: center;
      }
      .addWx {
        font-family: OPPOSans, OPPOSans;
        font-weight: normal;
        font-size: 0.18rem;
        color: #495a7b;
        margin-top: 0.1rem;
      }
    }
  }
  .fifth {
    .apply {
      padding: 0 0.86rem;
      .word {
        font-family: OPPOSans, OPPOSans;
        font-weight: 600;
        font-size: 0.2rem;
        color: #232323;
        margin-bottom: 0.15rem;
        &::before {
          content: "*";
          color: red;
        }
      }
      .word1 {
        font-family: OPPOSans, OPPOSans;
        font-weight: 600;
        font-size: 0.2rem;
        color: #232323;
        margin-bottom: 0.15rem;
      }
      .namePhone {
        display: flex;
        margin-top: 0.25rem;
        .input {
          width: 4.8rem;
          height: 0.5rem;
          border-radius: 0.06rem;
          border: 0.02rem solid #cdcdcd;
        }
      }
      .detail {
        margin: 0.31rem 0 0.1rem;
        .input {
          width: 10.29rem;
          height: 0.5rem;
          border-radius: 0.06rem;
          border: 0.02rem solid #cdcdcd;
        }
        .textArea {
          width: 10.3rem;
          height: 2.16rem;
          box-sizing: border-box;
          padding: 0.19rem 0 0 0.23rem;
          border-radius: 0.06rem;
          border: 0.02rem solid #cdcdcd;
          outline: none;
        }
      }
    }
    .submit {
      text-align: center;
      margin-top: 0.62rem;
      .button {
        margin: 0 auto;
        width: 2.4rem;
        height: 0.5rem;
        line-height: 0.5rem;
        background: #4089fe;
        border-radius: 0.25rem;
        font-family: OPPOSans, OPPOSans;
        font-weight: normal;
        font-size: 0.28rem;
        color: #ffffff;
        text-align: center;
        cursor: pointer;
      }
      .tip {
        margin-top: 0.18rem;
        font-family: OPPOSans, OPPOSans;
        font-weight: normal;
        font-size: 0.18rem;
        color: #232323;
      }
    }
  }
  .bigTitle {
    display: flex;
    align-items: center;
    margin: 0.43rem 0 0.36rem;
    .line {
      width: 0.08rem;
      height: 0.42rem;
      background: #4089fe;
      border-radius: 0.04px;
    }
    .topic {
      margin-left: 0.22rem;
      font-family: OPPOSans, OPPOSans;
      font-weight: normal;
      font-size: 0.4rem;
      color: #232323;
    }
  }
}
</style>
